import { VisuallyHidden } from "reakit";
import { Box } from "../../Box/Box";

import { YEARS_LIST_INTERVAL, COUNT_IN_ROW } from "../constants";
import { useCalendarContext } from "../context";
import { getStartYearsInterval, parseDate } from "../helpers";
import { Year } from "./Year/Year";

export function YearsCalendar() {
  const { currentDate, calendarId } = useCalendarContext();
  const originalDate = new Date(currentDate);
  const startYear = getStartYearsInterval(originalDate);
  const yearsInRow = COUNT_IN_ROW.years;

  let rows = [];
  let row = [];
  for (let year = 0; year < YEARS_LIST_INTERVAL; year++) {
    row.push(startYear + year);
    if ((year + 1) % yearsInRow === 0) {
      rows.push(row);
      row = [];
    }
  }

  return (
    <Box
      as="table"
      role="grid"
      aria-labelledby={calendarId}
      styles={{
        borderCollapse: "collapse",
        tableLayout: "fixed",
      }}
      width={1}
    >
      <VisuallyHidden as="caption">Выберите год</VisuallyHidden>
      <Box as="tbody">
        {rows.map((singleRow) => (
          <Box as="tr" key={singleRow[0]}>
            {singleRow.map((year) => (
              <Box key={year} as="td" border={1} borderColor="calendarBtnBorderColor" p={0}>
                <Year data-date={parseDate(new Date(year, 0, 1))} />
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
